import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Table,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Collapsible from "react-collapsible";
import MultiValueTextInput from "./MultiValueTextInput";
import {
  getMedicationcategory,
  updateMedication,
  getCity,
  GetAllSuppliers,
  checkMedication,
  getCountry,
  updateMedication_old_data,
  getpagewiseMedicationTag,
  Get_Medication_commision,
  getAllGenericName,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import SweetAlert from "react-bootstrap-sweetalert";
import { style } from "../../../variables/Variables";
import axios from "axios";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { genericNameOptions } from "./medicationUtil";

class editmedication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      //commision: "1",
      textFields: [],
      tagsdetails: [],
      searchTag: null,
      wt_commision: "",
      medicationcategory: [],
      m_category: "0",
      m_categoryError: null,
      description: "",
      batches: [],
      descriptionError: null,
      // price : '',
      unit_priceError: null,
      generic_name: null,
      generic_nameError: null,
      item_code: "",
      item_codeError: null,
      selling_price: "",
      unit_price: "",
      useraccess: "",
      quantity: "",
      row: "",
      column: "",
      barcode: "",
      sort_order: "",
      tags: [],
      keywordItems: [],
      display_discount: "",
      genericNameOptions: [],
      is_flash_medicine: "",
      _notificationSystem: null,
      cardHidden: true,
      city: "1",
      codeDisabled: "",
      package_image_data: [],
      packageImageError: null,
      package_image: [],
      packageitemdetails: [],
      packageitem: null,
      packageitemoptiondetails: [],
      primaryimage: "",
      localimagedata: [],
      cityError: null,
      city_info: [],
      itemcodeunique: "",
      errormessages: [],
      itemname: "",
      discounted_price: "",
      itemnameError: null,
      is_featured: "2",
      is_available: "0",
      suppliersData: [],
      supplier: null,
      deliver_within: "0",
      deliver_withinError: null,
      quantity_typeError: null,
      quantity_type: "2",
      showPerBox: false,
      quantity_per_box: "0",
      quantity_per_boxError: null,
      is_out_of_stock: "",
      medicationpackage: "0",
      labpackage: [],
      packageItems: [],
      setting_commision: "",
      tag: [],
      isSubmitting: false,
      isColumnError: null,
      isRowError: null,
      missingRequiredFieldError: null,
      dosage: "",
      dosageMedi: "",
      product_categories: "Medicine",
      enterGeneticName: false,
      EnterGenericName: "",
      route: "",
      packSize: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.isFalshMedicine = this.isFalshMedicine.bind(this);
    this.item_code_error = React.createRef();
  }

  handleMultiTextField(val) {
    this.setState({ textFields: val, tag: val });
  }

  isFalshMedicine = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_flash_medicine: checked });
  };

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var oldid = JSON.parse(localStorage.getItem("medicationID"));
    this.setState({
      useraccess: token.role,
    });

    // if (token.role != 1 && token.role != 11) {
    //   this.props.history.push("/admin/medication");
    // }
    getAllGenericName(obj).then((res) => {
      const genericNameOptions = (res.data || [])
        .filter((name) => typeof name === "string" && name.trim() !== "")
        .map((name) => ({ value: name, label: name }));
      this.setState({ genericNameOptions });
    });

    Get_Medication_commision(obj).then((res) => {
      if (res.data.success == true) {
        var com = res.data.data;
        this.setState({ setting_commision: com.setting_value });
        this.setState({ settingsloading: false });
      }
    });

    var madpackage = [];
    await updateMedication_old_data(oldid, obj).then((res) => {
      const data = res.data;
      console.log(data, "<<<=== Data");
      var hc = [];
      var newdata = [];
      hc = data.tags;
      if (hc == null || hc == "") {
        this.setState({ searchTag: null });
      } else {
        const splic = hc;

        hc.map((fd) => {
          newdata.push({ value: fd.id, label: fd.keyword });
        });
        this.setState({ searchTag: newdata });
      }

      /*var com = "";
      if (data.add_commision == 1) {
        com = "1";
      } else if (data.add_commision == 0) {
        com = "2";
      }*/

      var is_featured = "";
      if (data.is_featured == "1") {
        is_featured = "1";
      } else if (data.is_featured == "0") {
        is_featured = "2";
      }
      data.images.map((m) => {
        if (m.is_primary_image == 1) {
          this.setState({ primaryimage: m.image_url });
        }
      });
      var idata = [];
      data.images.map((m) => {
        idata.push(m.image_url);
      });

      var isoutofSt = "";
      if (data.is_out_of_stock == 1) {
        isoutofSt = true;
      } else {
        isoutofSt = false;
      }

      this.setState({
        m_category: data.category_id,
        itemname: data.title,
        description: data.description,
        // price : data.price,
        tags: data.tags,
        barcode: data.barcode,
        quantity: data.quantity,
        row: data.xcoord,
        column: data.ycoord,
        is_flash_medicine: data.is_flash_medicine,
        supplier: data.supplier,
        item_code: data.item_code,
        batches: data.batches,
        unit_price: data.unit_price,
        //commision: com,
        selling_price: data.price,
        is_out_of_stock: isoutofSt,
        //  city: data.country_id,
        city: 1,
        sort_order: data.sort_order,
        is_featured: is_featured,
        is_available: data.is_available,
        generic_name: { value: data.generic_name, label: data.generic_name },
        package_image_data: idata,
        localimagedata: data.images,
        quantity: data.total_quantity,
        barcode: data.barcode,
        is_flash_medicine: data.is_flash_medicine,
        supplier: data.supplier_id,
        display_discount: data.discounted_price,
        deliver_within: data.deliver_within,
        quantity_type: data.quantity_type,
        quantity_per_box: data.quantity_per_box,
        tag: data.tag_for_categorize,
        textFields: data.tag_for_categorize,
        dosageMedi: data.dosage,
        dosage: data.dosage_unit,
        product_categories: data.product_categories || "Medicine",
        route: data.route || null,
        packSize: data.pack_size || null,
      });

      // madpackage = data.package_id

      if (data.quantity_type == "1") {
        this.setState({ showPerBox: true });
      } else {
        this.setState({ showPerBox: false });
      }

      if (data.is_flash_medicine) {
        this.setState({ codeDisabled: "disabled" });
      } else {
        this.setState({ codeDisabled: "" });
      }
    });
    let compelte_hc = 1;
    let hc_pg_no = 1;
    this.setState({ tagsdetails: [] });
    // while (compelte_hc == 1) {
    var country_id = "1";
    await getpagewiseMedicationTag(hc_pg_no, this.state.m_category, obj).then(
      (res) => {
        const data = res.data.data;

        if (data.length == 0) {
          compelte_hc = 0;
          this.setState({
            keywordItems: [],
          });
        } else {
          // compelte_hc = 0;
          var array1 = this.state.tagsdetails;
          var array2 = array1.concat(data);

          this.setState({
            tagsdetails: array2,
          });

          let hcItems = [];
          this.state.tagsdetails.map((x, i) => {
            hcItems.push({
              value: x.id,
              label: x.keyword,
            });
          });
          this.setState({
            keywordItems: hcItems,
          });
        }
      },
    );
    hc_pg_no++;
    // }
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    var country_id = "1";
    getCountry(obj, country_id).then((res) => {
      this.setState({ city_info: res.data });
    });

    GetAllSuppliers(obj).then((res) => {
      this.setState({ suppliersData: res.data.data });
    });
    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await getMedicationcategory(obj, pg_no).then((response) => {
        const data = response.data;
        if (data.data.length == 0) {
          compelte = 0;
        } else {
          var array1 = this.state.medicationcategory;
          var array2 = array1.concat(data.data);
          this.setState({
            medicationcategory: array2,
          });
        }
      });
      pg_no++;
    }

    /*let compelte1 = 1
    let pg_no1 = 1
    var pcItems = []
    while (compelte1 == 1) {
      await getallmedicationpackages(obj, pg_no1)
        // .then((response) => response.json())
        .then((response) => {
          console.log(response)
          const mdata = response.data;
          if (mdata.data.length == 0) {
            compelte1 = 0
          }
          else {
            var array1 = this.state.labpackage
            var array2 = array1.concat(mdata.data)
            this.setState({
              labpackage: array2
            })

            this.state.labpackage.map((x, i) => {
              pcItems.push({ value: x.id, label: x.package_name })
            })
            this.setState({
              packageItems: pcItems
            })
          }
        })
      pg_no1++
    }

    var newdata1 = [];
    for (let i = 0; i < madpackage.length; i++) {
      for (let y = 0; y < pcItems.length; y++) {
        if (madpackage[i] == pcItems[y].value) {
          newdata1.push(pcItems[y])
        }

      }
    }
    this.setState({ medicationpackage: newdata1 });*/
  }
  // dropdown change
  categoryChange = async (event) => {
    //  console.log(event, "event");
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ m_category: value });

    if (value === "0") {
      this.setState({
        m_categoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ m_categoryError: null });
    }
    this.setState({ tagsdetails: [] });
    this.setState({
      keywordItems: [],
    });
    let compelte_hc = 1;
    let hc_pg_no = 1;
    while (compelte_hc == 1) {
      var country_id = "1";
      await getpagewiseMedicationTag(hc_pg_no, value, obj).then((res) => {
        const data = res.data.data;

        if (data.length == 0) {
          compelte_hc = 0;
        } else {
          // compelte_hc = 0;
          var array1 = this.state.tagsdetails;
          var array2 = array1.concat(data);

          this.setState({
            tagsdetails: array2,
          });

          let hcItems = [];
          this.state.tagsdetails.map((x, i) => {
            hcItems.push({
              value: x.id,
              label: x.keyword,
            });
          });
          this.setState({
            keywordItems: hcItems,
          });
        }
      });
      hc_pg_no++;
    }
  };
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  hideAlert() {
    this.setState({
      alert: null,
      isSubmitting: false,
    });
  }
  handleDiscountChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  isoutofstock = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_out_of_stock: checked });
  };

  handleCommissionChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({ unit_price: value });
    if (value === "") {
      this.setState({
        unit_priceError: (
          <small className="text-danger">Buying Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
  };

  confirmSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.itemname.length == 0) {
      error = true;
      this.setState({
        itemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ itemnameError: null });
    }
    if (this.state.unit_price.length == 0) {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Buying Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
    if (this.state.m_category == "0") {
      error = true;
      this.setState({
        m_categoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ m_categoryError: null });
    }
    if (this.state.city == "0") {
      error = true;
      this.setState({
        cityError: <small className="text-danger">City is required.</small>,
      });
    } else {
      this.setState({ cityError: null });
    }
    if (
      this.state.is_flash_medicine === 0 ||
      this.state.is_flash_medicine === ""
    ) {
      if (this.state.item_code.length == 0) {
        error = true;
        this.setState({
          item_codeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ item_codeError: null });
      }
    }

    if (this.state.quantity_type == "0") {
      error = true;
      this.setState({
        quantity_typeError: (
          <small className="text-danger">Quantity Type is required.</small>
        ),
      });
    } else {
      this.setState({ quantity_typeError: null });
    }

    if (this.state.quantity_type == 1) {
      if (this.state.quantity_type == 0) {
        console.log("quantity_type");
        error = true;
        this.setState({
          quantity_typeError: (
            <small className="text-danger">Quantity Type is required.</small>
          ),
        });
      } else {
        this.setState({ quantity_typeError: null });
      }
    } else {
      this.setState({ quantity_per_box: "0" });
    }
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (!error) {
      var packageimages = this.state.package_image_data;

      var data_unit_price = "";
      var oldid = JSON.parse(localStorage.getItem("medicationID"));

      /*var commision = "";
      if (this.state.commision == "1") {
        commision = "1";
      } else if (this.state.commision == "2") {
        commision = "0";
      }*/

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }
      var tag = [];

      if (this.state.searchTag == null) {
        tag = "";
      } else {
        this.state.searchTag.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.value);
          tag = array2;
        });
      }

      var ismadicineout = "";
      if (this.state.is_out_of_stock) {
        ismadicineout = 1;
      } else {
        ismadicineout = 0;
      }

      const genericNameForSubmit =
        this.state.enterGeneticName &&
        (!this.state.generic_name || this.state.generic_name.trim() === "")
          ? this.state.EnterGenericName
          : this.state.generic_name;

      /*var package_d = [];
      if (this.state.medicationpackage == null) {
        package_d = ""
      }
      else {
        this.state.medicationpackage.map(data => {
          var array1 = package_d;
          var array2 = array1.concat(data.value);
          package_d = array2
        })
      }*/

      updateMedication(
        this.state.itemname,
        this.state.m_category,
        itemCode,
        //commision,
        this.state.unit_price,
        this.state.city,
        this.state.description,
        is_featured,
        oldid,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.row,
        this.state.column,
        this.state.display_discount,
        this.state.supplier,
        this.state.primaryimage,
        packageimages,
        tag,
        this.state.sort_order,
        this.state.generic_name ? this.state.generic_name.value : null,
        this.state.packSize,
        this.state.is_available,
        this.state.selling_price,
        this.state.deliver_within,
        this.state.quantity_type,
        this.state.quantity_per_box,
        ismadicineout,
        this.state.tag,
        this.state.dosageMedi,
        this.state.dosage,
        this.state.product_categories,
        this.state.route,
        //package_d,
        obj,
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.item_code_error.current.focus();
              this.setState({
                item_codeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
              this.setState({ isSubmitting: false });
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({ isSubmitting: false });
          }

          // this.props.history.push('/admin/medication');
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    }
  };
  onSubmit = async () => {
    this.setState({ errormessages: [], missingRequiredFieldError: null });
    let error = false;

    if (this.state.itemname.length == 0) {
      error = true;
      this.setState({
        itemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ itemnameError: null });
    }
    if (this.state.unit_price.length == 0) {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Buying Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
    if (this.state.m_category == "0") {
      error = true;
      this.setState({
        m_categoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ m_categoryError: null });
    }
    if (!this.state.row) {
      error = true;
      this.setState({
        isRowError: <small className="text-danger">Row is required.</small>,
      });
    } else {
      this.setState({ isRowError: null });
    }
    if (!this.state.column) {
      error = true;
      this.setState({
        isColumnError: (
          <small className="text-danger">Column is required.</small>
        ),
      });
    } else {
      this.setState({ isColumnError: null });
    }
    if (this.state.city == "0") {
      error = true;
      this.setState({
        cityError: <small className="text-danger">City is required.</small>,
      });
    } else {
      this.setState({ cityError: null });
    }
    if (
      this.state.is_flash_medicine === 0 ||
      this.state.is_flash_medicine === ""
    ) {
      if (this.state.item_code.length == 0) {
        error = true;
        this.setState({
          item_codeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ item_codeError: null });
      }
    }

    if (this.state.quantity_type == "0") {
      error = true;
      this.setState({
        quantity_typeError: (
          <small className="text-danger">Quantity Type is required.</small>
        ),
      });
    } else {
      this.setState({ quantity_typeError: null });
    }

    if (this.state.quantity_type == 1) {
      if (this.state.quantity_type == 0) {
        console.log("quantity_type");
        error = true;
        this.setState({
          quantity_typeError: (
            <small className="text-danger">Quantity Type is required.</small>
          ),
        });
      } else {
        this.setState({ quantity_typeError: null });
      }
    } else {
      this.setState({ quantity_per_box: "0" });
    }
    if (error) {
      this.setState({
        missingRequiredFieldError: (
          <small className="text-danger">
            Some fields are required. Please fill them.
          </small>
        ),
      });
      return;
    }
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await checkMedication(
      this.state.itemname,
      JSON.parse(localStorage.getItem("medicationID")),
      obj,
    ).then((res) => {
      if (res.data.success === false) {
        error = true;
        this.setState({
          alert: (
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="Are you sure?"
              onConfirm={() =>
                this.confirmSubmit(
                  JSON.parse(localStorage.getItem("medicationID")),
                )
              }
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              confirmBtnText="Yes, add it!"
              cancelBtnText="Cancel"
              showCancel
            >
              <h4>
                This medication name already exist. Are you sure you want to add
                it!
              </h4>
              {res.data.data.length != 0 && (
                <React.Fragment>
                  <h6>Available Medicine</h6>
                  {res.data.data.map((exdata) => (
                    <p>
                      #{exdata.id} -{exdata.title} - {exdata.item_code}
                    </p>
                  ))}
                </React.Fragment>
              )}
            </SweetAlert>
          ),
        });
      }
    });

    if (!error) {
      var packageimages = this.state.package_image_data;

      var data_unit_price = "";
      var oldid = JSON.parse(localStorage.getItem("medicationID"));

      /*var commision = "";
      if (this.state.commision == "1") {
        commision = "1";
      } else if (this.state.commision == "2") {
        commision = "0";
      }*/

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }
      var tag = [];

      if (this.state.searchTag == null) {
        tag = "";
      } else {
        this.state.searchTag.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.value);
          tag = array2;
        });
      }

      var ismadicineout = "";
      if (this.state.is_out_of_stock) {
        ismadicineout = 1;
      } else {
        ismadicineout = 0;
      }

      const genericNameForSubmit =
        this.state.enterGeneticName &&
        (!this.state.generic_name || this.state.generic_name.trim() === "")
          ? this.state.EnterGenericName
          : this.state.generic_name;

      /* var package_d = [];
      if(this.state.medicationpackage == null)
      {
        package_d = ""
      }
      else
      {
      this.state.medicationpackage.map(data => {
        var array1 = package_d; 
        var array2 =  array1.concat(data.value);
        package_d = array2
      })
    }*/

      updateMedication(
        this.state.itemname,
        this.state.m_category,
        itemCode,
        //commision,
        this.state.unit_price,
        this.state.city,
        this.state.description,
        is_featured,
        oldid,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.row,
        this.state.column,
        this.state.display_discount,
        this.state.supplier,
        this.state.primaryimage,
        packageimages,
        tag,
        this.state.sort_order,
        this.state.generic_name ? this.state.generic_name.value : null,
        this.state.packSize,
        this.state.is_available,
        this.state.selling_price,
        this.state.deliver_within,
        this.state.quantity_type,
        this.state.quantity_per_box,
        ismadicineout,
        this.state.tag,
        this.state.dosageMedi,
        this.state.dosage,
        this.state.product_categories,
        this.state.route,
        //package_d,
        obj,
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.item_code_error.current.focus();
              this.setState({
                item_codeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({ isSubmitting: false });
          }

          this.props.history.push("/admin/medication");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    }
  };
  upload() {
    document.getElementById("selectImage").click();
  }
  handleFileChange = async (event) => {
    let data = [];
    data.push(event.target.files);
    this.setState({ package_image: data });

    var packageimages = "";
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (data.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      data.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("image_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/image";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          packageimages = res.data.data.image_url;
          this.setState({ package_image_data: packageimages });
        });
    } else {
      let pdata = [];

      this.state.package_image_data.map((p) => {
        if (p.length != 0) {
          pdata.push(p);
        }
      });
      packageimages = pdata;
      this.setState({ package_image_data: packageimages });
    }
  };
  handleChange(tags) {
    this.setState({ tags });
  }

  handleQuantity_per_box_chnage(event) {
    this.setState({ quantity_per_box: event.target.value });
    event.target.value === ""
      ? this.setState({
          quantity_per_boxError: (
            <small className="text-danger">Quantity per box is required.</small>
          ),
        })
      : this.setState({ type_textError: null });
  }

  // handleQuantity_type_chnage(event) {
  //   this.setState({ quantity_type: event.target.value });
  //   if (event.target.value == 1) {
  //     this.setState({ showPerBox: true });
  //   } else {
  //     this.setState({ quantity_per_box: "0" });
  //     this.setState({ showPerBox: false });
  //   }

  //   event.target.value === "0"
  //     ? this.setState({
  //         quantity_typeError: (
  //           <small className="text-danger">Quantity Type is required.</small>
  //         ),
  //       })
  //     : this.setState({ quantity_typeError: null });
  // }

  render() {
    const { textFields } = this.state;
    const medicaioncat = this.state.medicationcategory;
    const city_info = this.state.city_info;
    const itemcodeunique = this.state.itemcodeunique;
    const errormessages = this.state.errormessages;
    const dosageOptions = [
      "mg",
      "g",
      "mcg",
      "ml",
      "mg/ml",
      "mg/5 ml",
      "%",
      "IU",
      "IU/ml",
      "mcg/dose",
      "mg/dose",
      "mg/g",
    ].map((item) => ({ value: item, label: item }));
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.item_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          {this.state.alert}
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <Checkbox
                        number="50"
                        checked={this.state.is_flash_medicine}
                        onChange={(e) => this.isFalshMedicine(e)}
                        label="Is Flash Medicine / Product?"
                      ></Checkbox>
                    </FormGroup>
                    {this.state.is_flash_medicine == 1 && (
                      <FormGroup>
                        <ControlLabel>Supplier</ControlLabel>
                        <select
                          className="react-select primary form-control"
                          name="supplier"
                          value={this.state.supplier}
                          onChange={(event) => {
                            this.setState({ supplier: event.target.value });
                          }}
                        >
                          <option value="0">Select Supplier</option>
                          {this.state.suppliersData.map((cus) => (
                            <option value={cus.id}>{cus.name}</option>
                          ))}
                        </select>
                      </FormGroup>
                    )}

                    <FormGroup>
                      <ControlLabel>Product Categories</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({
                            product_categories: event.target.value,
                          });
                        }}
                        value={this.state.product_categories}
                        className="form-control"
                        placeholder="product Categories"
                      >
                        <option value="">Select Product Categories</option>
                        <option value="Medicine">Medicine</option>
                        <option value="Hygiene">Hygiene</option>
                        <option value="Safety">Safety</option>
                        <option value="Medical Device">Medical Device</option>
                        <option value="Surgical Item">Surgical Item</option>
                        <option value="FMCG">FMCG</option>
                        <option value="Supplement">Supplement</option>
                        <option value="Herbal">Herbal</option>
                        <option value="Retail Item">Retail Item</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Item Code</ControlLabel>
                      <FormControl
                        name="item_code"
                        value={this.state.item_code}
                        disabled={this.state.codeDisabled}
                        onChange={(event) => {
                          this.setState({ item_code: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                item_codeError: (
                                  <small className="text-danger">
                                    ItemCode is required.
                                  </small>
                                ),
                              })
                            : this.setState({ item_codeError: null });
                        }}
                        placeholder="Enter ItemCode"
                      />
                      {this.state.item_codeError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Item / Brand Name</ControlLabel>
                      <FormControl
                        name="itemname"
                        value={this.state.itemname}
                        onChange={(event) => {
                          this.setState({ itemname: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                itemnameError: (
                                  <small className="text-danger">
                                    Item Name is required.
                                  </small>
                                ),
                              })
                            : this.setState({ itemnameError: null });
                        }}
                        placeholder="Enter Item Name"
                        type="text"
                      />
                      {this.state.itemnameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Route</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({
                            route: event.target.value,
                          });
                        }}
                        value={this.state.route}
                        className="form-control"
                        placeholder="Select Route"
                      >
                        <option value="">Select Route</option>
                        <option value="Oral (PO) – by mouth (tablets, syrups)">
                          Oral (PO) – by mouth (tablets, syrups)
                        </option>
                        <option value="Sublingual / Buccal – under the tongue or inside cheek">
                          Sublingual / Buccal – under the tongue or inside cheek
                        </option>
                        <option value="Topical – on the skin (creams, ointments)">
                          Topical – on the skin (creams, ointments)
                        </option>
                        <option value="Transdermal – patch on skin (slow release)">
                          Transdermal – patch on skin (slow release)
                        </option>
                        <option value="Inhalation – breathed in (inhalers, nebulizers)">
                          Inhalation – breathed in (inhalers, nebulizers)
                        </option>
                        <option value="Injection">Injection</option>
                        <option value="IV – into vein">IV – into vein</option>
                        <option value="IM – into muscle">
                          IM – into muscle
                        </option>
                        <option value="SC – under skin">SC – under skin</option>
                        <option value="ID – into skin">ID – into skin</option>
                        <option value="Rectal – suppositories">
                          Rectal – suppositories
                        </option>
                        <option value="Vaginal – pessaries, creams">
                          Vaginal – pessaries, creams
                        </option>
                        <option value="Nasal – nose drops/sprays">
                          Nasal – nose drops/sprays
                        </option>
                        <option value="Ophthalmic – eye drops">
                          Ophthalmic – eye drops
                        </option>
                        <option value="Otic – ear drops">
                          Otic – ear drops
                        </option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Generic Name</ControlLabel>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Select Generic Name"
                        name="generic_name"
                        value={this.state.generic_name}
                        onChange={(value) => {
                          console.log(value);
                          this.setState({
                            generic_name: value,
                          });
                        }}
                        options={genericNameOptions}
                      />
                      {this.state.generic_nameError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Pack Size (Per Box)</ControlLabel>
                      <FormControl
                        name="packSize"
                        value={this.state.packSize}
                        onChange={(event) => {
                          this.setState({ packSize: event.target.value });
                        }}
                        placeholder="Enter pack size "
                        type="number"
                        onWheel={(e) => e.target.blur()}
                      />
                      {this.state.packSizeError}
                    </FormGroup>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <ControlLabel>Dosage</ControlLabel>
                          <FormControl
                            name="dosageMedi"
                            value={this.state.dosageMedi}
                            onChange={(event) => {
                              this.setState({
                                dosageMedi: event.target.value,
                              });
                            }}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter Dosage"
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup style={{ marginTop: "5px" }}>
                          <ControlLabel>Dosage Unit</ControlLabel>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="dosage"
                            options={dosageOptions}
                            value={
                              dosageOptions.find(
                                (option) => option.value === this.state.dosage,
                              ) || null
                            }
                            onChange={(option) => {
                              this.setState({
                                dosage: option ? option.value : "",
                              });
                            }}
                            placeholder="Select Unit"
                            isClearable
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/*<FormGroup>
                      <ControlLabel>Package</ControlLabel>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Package"
                        name="package"
                        closeMenuOnSelect={false}
                        isMulti
                        value={this.state.medicationpackage}
                        onChange={value => {
                          console.log(value)
                          this.setState({
                            medicationpackage: value
                          })
                        }
                        }
                        options={this.state.packageItems}
                      />

                     
                      </FormGroup>*/}

                    <FormGroup>
                      <ControlLabel>Buying Price</ControlLabel>
                      <FormControl
                        name="unit_price"
                        value={this.state.unit_price}
                        onChange={(e) => this.handleInputChange(e)}
                        placeholder="Enter Buying Price"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                      />
                      {this.state.unit_priceError}
                    </FormGroup>
                    {/*<FormGroup>
                      <ControlLabel>Commision</ControlLabel>
                      <Radio
                        number="5"
                        option="1"
                        name="commision"
                        onChange={(e) => this.handleCommissionChange(e)}
                        checked={this.state.commision === "1"}
                        label="Add"
                      />
                      <Radio
                        number="6"
                        option="2"
                        name="commision"
                        onChange={(e) => this.handleCommissionChange(e)}
                        checked={this.state.commision === "2"}
                        label="Not add"
                      />
                    </FormGroup>*/}
                    <FormGroup>
                      <ControlLabel>
                        Selling Price (Per Item/Tablet)
                      </ControlLabel>
                      <FormControl
                        name="selling_price"
                        value={this.state.selling_price}
                        placeholder="Enter selling Price"
                        type="number"
                        onChange={(event) => {
                          this.setState({
                            selling_price: event.target.value,
                          });
                        }}
                        onWheel={(e) => e.target.blur()}
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Display Discount</ControlLabel>
                      <FormControl
                        name="display_discount"
                        value={this.state.display_discount}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter Display Discount"
                        onChange={(event) => {
                          this.setState({
                            display_discount: event.target.value,
                          });
                        }}
                        type="number"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Medication Sub-Categories</ControlLabel>
                      {/* <TagsInput
                        value={this.state.tags}
                        onChange={(e) => this.handleChange(e)}
                      />*/}
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Medication Sub-Categories"
                        name="searchTag"
                        closeMenuOnSelect={false}
                        isMulti
                        value={this.state.searchTag}
                        onChange={(value) =>
                          this.setState({
                            searchTag: value,
                          })
                        }
                        options={this.state.keywordItems}
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Country</ControlLabel>
                      <select
                        className="react-select primary form-control"
                        name="city"
                        value={this.state.city}
                        onChange={(event) => {
                          this.setState({ city: event.target.value });
                          event.target.value === "0"
                            ? this.setState({
                                cityError: (
                                  <small className="text-danger">
                                    Country is required.
                                  </small>
                                ),
                              })
                            : this.setState({ cityError: null });
                        }}
                      >
                        {city_info.map((cus) => (
                          <option selected value={cus.id}>
                            {cus.country_name}
                          </option>
                        ))}
                      </select>
                      {this.state.cityError}
                    </FormGroup>

                    {/* <FormGroup>
                      <ControlLabel>Quantity Type</ControlLabel>

                      <div className="order_source_data">
                        <Radio
                          number="31"
                          option="1"
                          name="quantity_type"
                          onChange={(event) =>
                            this.handleQuantity_type_chnage(event)
                          }
                          checked={this.state.quantity_type == "1"}
                          label="Quantiy Per Box"
                        />
                        &nbsp;
                        <Radio
                          number="32"
                          option="2"
                          name="quantity_type"
                          onChange={(event) =>
                            this.handleQuantity_type_chnage(event)
                          }
                          checked={this.state.quantity_type == "2"}
                          label="Quantiy Per Item/Tablet"
                        />
                      </div>
                      {this.state.quantity_typeError}
                    </FormGroup>

                    {this.state.showPerBox == true && (
                      <FormGroup>
                        <ControlLabel>Quantity Per Box</ControlLabel>
                        <FormControl
                          type="text"
                          onChange={(event) =>
                            this.handleQuantity_per_box_chnage(event)
                          }
                          required
                          name="quantity_per_box "
                          value={this.state.quantity_per_box || ""}
                          placeholder="Quantity Per Box"
                        />
                        {this.state.quantity_per_boxError}
                      </FormGroup>
                    )} */}

                    {/* {this.category_drop} */}
                    <FormGroup>
                      <ControlLabel>Quantity</ControlLabel>
                      <FormControl
                        readOnly
                        name="quantity"
                        value={this.state.quantity}
                        onChange={(event) => {
                          this.setState({ quantity: event.target.value });
                        }}
                        placeholder="Enter quantity"
                        type="integer"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>column</ControlLabel>
                      <FormControl
                        name="column"
                        value={this.state.column}
                        onChange={(event) => {
                          this.setState({
                            column: event.target.value,
                            isColumnError: null,
                          });
                        }}
                        placeholder="Enter column "
                        type="text"
                      />
                      {this.state.isColumnError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Row</ControlLabel>
                      <FormControl
                        name="row"
                        value={this.state.row}
                        onChange={(event) => {
                          this.setState({
                            row: event.target.value,
                            isRowError: null,
                          });
                        }}
                        placeholder="Enter row "
                        type="text"
                      />
                      {this.state.isRowError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Sort Order</ControlLabel>
                      <FormControl
                        name="sort_order"
                        value={this.state.sort_order}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter Sort Order"
                        onChange={(event) => {
                          this.setState({
                            sort_order: event.target.value,
                          });
                        }}
                        type="number"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Barcode</ControlLabel>
                      <FormControl
                        name="barcode"
                        value={this.state.barcode}
                        onChange={(event) => {
                          this.setState({ barcode: event.target.value });
                        }}
                        placeholder="Enter Barcode"
                        type="text"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Description</ControlLabel>
                      <textarea
                        name="description"
                        className="form-control"
                        value={this.state.description}
                        onChange={(event) => {
                          this.setState({ description: event.target.value });
                        }}
                        placeholder="Enter Description"
                        cols={3}
                        rows={2}
                      ></textarea>
                      {this.state.descriptionError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Delivery within</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({ deliver_within: event.target.value });
                        }}
                        value={this.state.deliver_within}
                        className="form-control"
                      >
                        <option value="">Select Delivery within</option>
                        <option value="1 - 3 Days">1 - 3 Days</option>
                        <option value="3 - 7 Days">3 - 7 Days</option>
                        <option value="7 - 14 Days">7 - 14 Days</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Images</ControlLabel>
                      <br></br>

                      <div className="col-md-12">
                        <div className="col-md-4 no-padding">
                          <input
                            style={{ display: "none" }}
                            id="selectImage"
                            type="file"
                            className="form-control"
                            name="package_image"
                            multiple
                            onChange={this.handleFileChange}
                          />
                          <Button
                            onClick={this.upload}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.package_image == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.package_image == ""
                              ? "Choose File"
                              : "Change File"}
                          </Button>
                        </div>
                      </div>
                      {this.state.packageImageError}
                    </FormGroup>
                    <FormGroup>
                      <Table>
                        <tr>
                          {this.state.package_image_data.map((pid, i) => (
                            <>
                              <td style={{ width: "30px" }}>
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number={"15" + i}
                                  option={pid}
                                  name="primaryimage"
                                  onChange={this.onChange}
                                  checked={this.state.primaryimage === pid}
                                  //  label="Web"
                                />
                              </td>
                              <td>
                                <a href={pid} target="_blank">
                                  <img
                                    src={pid}
                                    style={{ height: "30px", width: "30px" }}
                                  ></img>
                                </a>
                              </td>
                            </>
                          ))}
                        </tr>
                      </Table>
                    </FormGroup>
                    <FormGroup className="">
                      <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                      <Radio
                        number="7"
                        option="1"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "1"}
                        label="Yes"
                      />
                      <Radio
                        number="8"
                        option="2"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "2"}
                        label="No"
                      />
                    </FormGroup>
                    <FormGroup className="">
                      <ControlLabel>Is Available ? &nbsp;</ControlLabel>
                      <Radio
                        number="14"
                        option="1"
                        name="is_available"
                        onChange={this.onChange}
                        checked={this.state.is_available == "1" ? true : false}
                        label="available"
                      />
                      <Radio
                        number="16"
                        option="0"
                        name="is_available"
                        onChange={this.onChange}
                        checked={this.state.is_available == "0" ? true : false}
                        label="unavailable"
                      />
                    </FormGroup>
                    <br />
                    <FormGroup>
                      <Checkbox
                        number="68"
                        checked={this.state.is_out_of_stock}
                        onChange={(e) => this.isoutofstock(e)}
                        label="Is Out of Stock?"
                      ></Checkbox>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Tags </ControlLabel>
                      <MultiValueTextInput
                        textFields={textFields}
                        handleMultiTextField={(val) =>
                          this.handleMultiTextField(val)
                        }
                      />
                    </FormGroup>

                    {/* { !(this.state.batches === "" || this.state.batches === null || this.state.batches.length === 0) && 
                    <FormGroup>
                    <ControlLabel>Batches </ControlLabel>
                    {
                      Object.entries(this.state.batches).map(([batchNo, count]) =>{
                        return(
                          <li key={batchNo}>
                          {batchNo.replace('batchNo-', '')}: {count}
                        </li>
                        )
                      })
                    }
                    
                  </FormGroup> } */}

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                      disabled={this.state.isSubmitting}
                    >
                      {this.state.isSubmitting ? "Updating..." : "Update"}
                    </Button>
                    <br />
                    {this.state.missingRequiredFieldError
                      ? this.state.missingRequiredFieldError
                      : null}
                  </form>
                }
              />
            </Col>
            <Row style={{ padding: "0 30px" }}>
              <Col
                md={12}
                className="collapeablecomp_orderhistory"
                style={{
                  background: "#ffff",
                  padding: "16px",
                  marginTop: "-16px",
                }}
              >
                <Collapsible trigger="Batches" transitionTime={200} open>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Batch No</th>
                        <th>Total Quantity</th>
                        <th>Created At</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(this.state.batches).length === 0 ? (
                        <tr>
                          <td
                            colSpan="4"
                            style={{ textAlign: "center", padding: "16px" }}
                          >
                            <h5 style={{ fontWeight: "500" }}>
                              No Records Found
                            </h5>
                          </td>
                        </tr>
                      ) : (
                        Object.entries(this.state.batches).map(
                          ([batchNo, batchArray], index) => {
                            const batchValue = batchNo.replace("batchNo-", "");
                            return batchArray.map((batch, batchIndex) => (
                              <tr key={`${index}-${batchIndex}`}>
                                <td>{batchValue}</td>
                                <td>{batch.quantity}</td>
                                <td>{batch.created_at}</td>
                                <td>{batch.unit_price}</td>
                              </tr>
                            ));
                          },
                        )
                      )}
                    </tbody>
                  </Table>
                </Collapsible>
              </Col>
            </Row>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editmedication;
